// G-C5: literales en euskera (default) y castellano.
export type Lang = 'eu' | 'es'

export const PILLS_ESTADO = ['CONV', 'JUG', 'TIT'] as const
// Issue #69: "Trabajo" (TR) — jugadores que faltan a partidos por trabajar (regional/juvenil).
export const PILLS_BAJA = ['LES', 'SAN', 'ENF', 'VAC', 'TR', 'NJ'] as const
export type PillEstado = (typeof PILLS_ESTADO)[number]
export type PillBaja = (typeof PILLS_BAJA)[number]

const DICT = {
  minutaje: { eu: 'Minutajea', es: 'Minutaje' },
  jornadaTab: { eu: 'Jardunaldia', es: 'Jornada' },
  dashboardTab: { eu: 'Dashboarda', es: 'Dashboard' },
  jornadaNumero: { eu: 'Jardunaldia zk.', es: 'Jornada nº' },
  nuevaJornada: { eu: 'Jardunaldi berria', es: 'Nueva jornada' },
  sinRegistrar: { eu: 'erregistratu gabe', es: 'sin registrar' },
  rival: { eu: 'Aurkaria', es: 'Rival' },
  fecha: { eu: 'Data', es: 'Fecha' },
  campo: { eu: 'Zelaia', es: 'Campo' },
  local: { eu: 'Etxean', es: 'Local' },
  visitante: { eu: 'Kanpoan', es: 'Visitante' },
  golesFavor: { eu: 'Gol alde', es: 'Goles favor' },
  golesContra: { eu: 'Gol kontra', es: 'Goles contra' },
  duracionPartido: { eu: 'partiduaren iraupena', es: 'duración del partido' },
  duracion: { eu: 'Iraupena', es: 'Duración' },
  // Feedback del cliente, 2026-10-05: un jugador no convocado en una jornada mostraba todo a 0/en
  // blanco, indistinguible visualmente de "la jornada no ha cargado" — confundía al confundirse con
  // un fallo real. Etiqueta explícita para dejarlo claro.
  noConvocado: { eu: 'Ez deitua', es: 'No convocado' },
  conv: { eu: 'DEI', es: 'CONV' },
  jug: { eu: 'JOK', es: 'JUG' },
  tit: { eu: 'TIT', es: 'TIT' },
  les: { eu: 'LES', es: 'LES' },
  san: { eu: 'ZIG', es: 'SAN' },
  enf: { eu: 'GAI', es: 'ENF' },
  vac: { eu: 'OPO', es: 'VAC' },
  tr: { eu: 'LAN', es: 'TR' },
  nj: { eu: 'JG', es: 'NJ' },
  minutos: { eu: 'Minutuak', es: 'Minutos' },
  goles: { eu: 'Golak', es: 'Goles' },
  amarillas: { eu: 'Txartel horiak', es: 'Amarillas' },
  rojas: { eu: 'Txartel gorriak', es: 'Rojas' },
  sanciones: { eu: 'Zigorrak', es: 'Sanciones' },
  sancionado: { eu: 'Zigortua', es: 'Sancionado' },
  unPeriodo: { eu: '1 zatia', es: '1 periodo' },
  partidoCompleto: { eu: 'partidu osoa', es: 'partido completo' },
  tresPeriodos: { eu: '3 zati', es: '3 periodos' },
  convocadosContador: { eu: 'dei · jokatu', es: 'conv · jugados' },
  guardarJornada: { eu: '💾 JARDUNALDIA GORDE', es: '💾 GUARDAR JORNADA' },
  historial: { eu: 'JARDUNALDIEN HISTORIALA', es: 'HISTORIAL DE JORNADAS' },
  registradas: { eu: 'erregistratuta', es: 'registradas' },
  sinJornadas: { eu: 'Oraindik ez dago jardunaldirik erregistratuta', es: 'Sin jornadas registradas aún' },
  // Bug real, feedback del cliente, 2026-10-02: "he rellenado los minutajes y cuando guardo
  // jornada luego no puedo abrirla y verlo" — si `loadJornada` fallaba por cualquier motivo
  // distinto de 403, no había ningún mensaje ni botón de reintentar, solo un spinner infinito.
  errorGenerico: { eu: 'Ezin izan da jardunaldia kargatu', es: 'No se ha podido cargar la jornada' },
  reintentar: { eu: 'Berriz saiatu', es: 'Reintentar' },
  jornadas: { eu: 'Jardunaldiak', es: 'Jornadas' },
  jugador: { eu: 'Jokalaria', es: 'Jugador' },
  // Issue #70: en las estadísticas del jugador se ve la palabra completa, no "Conv".
  conv2: { eu: 'Deiak', es: 'Convocado' },
  jugados: { eu: 'Jokatuak', es: 'Jugados' },
  titular: { eu: 'Titular', es: 'Titular' },
  // Issue #47, 2026-10-02: ventana de estadísticas de minutaje al hacer click en el jugador.
  estadisticasJugador: { eu: 'Jokalariaren estatistikak', es: 'Estadísticas del jugador' },
  noJugados: { eu: 'Jokatu gabeko partiduak', es: 'Partidos no jugados' },
  cerrar: { eu: 'Itxi', es: 'Cerrar' },
  porcTotal: { eu: '%GUZTIRA', es: '%TOTAL' },
  porcConv: { eu: '%DEI', es: '%CONV' },
  porcDisp: { eu: '%ERABILGARRI▲', es: '%DISP▲' },
  alertaIntervenir: { eu: '⚠️ Parte-hartze txikia', es: '⚠️ Participación baja' },
  alertaVigilar: { eu: '👁 Parte-hartze ertaina', es: '👁 Participación media' },
  kpiEquipo: { eu: 'Taldearen KPIak', es: 'KPIs del equipo' },
  controlParticipacion: { eu: 'PARTE-HARTZE KONTROLA', es: 'CONTROL DE PARTICIPACIÓN' },
  leyendaExplicacion: {
    eu: 'DISP▲ da metrika nagusia: <50% Esku hartu, 50-70% Zaindu, >=70% ondo',
    es: 'DISP▲ es la métrica principal: <50% Intervenir, 50-70% Vigilar, >=70% bien',
  },
  panelAlertas: { eu: 'Alerta jokalariak', es: 'Jugadores en alerta' },
  detallePorJornada: { eu: 'JARDUNALDIKA XEHETASUNA', es: 'DETALLE POR JORNADA' },
  tablaToggle: { eu: '☰ Taula', es: '☰ Tabla' },
  fichasToggle: { eu: '⊞ Fitxak', es: '⊞ Fichas' },
  // Dashboard (look & feel, 2026-10-22)
  balance: { eu: 'Balantzea (I-B-G)', es: 'Balance (V-E-D)' },
  golesFavorContra: { eu: 'Golak alde / kontra', es: 'Goles a favor / en contra' },
  estado: { eu: 'Egoera', es: 'Estado' },
  baja: { eu: 'Baja', es: 'Baja' },
  jornadaAnterior: { eu: 'Aurreko jardunaldia', es: 'Jornada anterior' },
  jornadaSiguiente: { eu: 'Hurrengo jardunaldia', es: 'Jornada siguiente' },
  gol: { eu: 'gol', es: 'gol' },
  min: { eu: 'min', es: 'min' },
} as const

export type DictKey = keyof typeof DICT


export function t(key: DictKey, lang: Lang): string {
  return DICT[key][lang]
}

export function umbralMinutaje(porcentaje: number | '--'): 'verde' | 'ambar' | 'rojo' | 'gris' {
  if (porcentaje === '--') return 'gris'
  if (porcentaje >= 70) return 'verde'
  if (porcentaje >= 50) return 'ambar'
  return 'rojo'
}

export const UMBRAL_COLOR: Record<ReturnType<typeof umbralMinutaje>, string> = {
  verde: 'var(--color-success)',
  ambar: 'var(--color-warning)',
  rojo: 'var(--color-danger)',
  gris: 'var(--color-neutral)',
}
